import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EMPTY, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { DialogService } from '../../../core/services/dialog.service';
// eslint-disable-next-line max-len
import { PaymentDetailsNotConsistentDialogComponent } from '../../components/payment-details-not-consistent-dialog/payment-details-not-consistent-dialog.component';
import { Payment } from '../../models/payment.model';
// eslint-disable-next-line max-len
import { PaymentService } from '../../services/payment.service';

@Component({
standalone: false,
  selector: 'app-payment-details-not-consistent-dialog-entry',
  styles: [''],
  template: '',
})
export class PaymentDetailsNotConsistentDialogEntryComponent implements OnInit {
  constructor(
    private dialog: DialogService,
    private route: ActivatedRoute,
    private router: Router,
    private paymentService: PaymentService,
  ) {}

  public ngOnInit(): void {
    const paymentId = this.route.parent.snapshot.paramMap.get('id');

    this.paymentService
      .getPayment(paymentId)
      .pipe(
        map(getMode),
        switchMap((mode) => this.openDialog(mode)),
        switchMap((result) => {
          if (result === 'recreate') {
            return this.recreatePayment(paymentId);
          } else if (result === 'cancel') {
            return this.cancelPayment(paymentId);
          } else {
            return EMPTY;
          }
        }),
      )
      .subscribe();
  }

  private openDialog(mode: Mode): Observable<any> {
    return this.dialog
      .open(PaymentDetailsNotConsistentDialogComponent, {
        data: mode,
        maxWidth: 386,
      })
      .afterClosed();
  }

  private recreatePayment(paymentId: string): Observable<any> {
    return this.paymentService
      .recreatePayment(paymentId)
      .pipe(switchMap((newPaymentId) => this.router.navigate(['/liabilities/pay', newPaymentId])));
  }

  private cancelPayment(paymentId: string): Observable<any> {
    return this.paymentService
      .cancelPayment(paymentId)
      .pipe(switchMap(() => this.router.navigate(['/liabilities/all'])));
  }
}

function getMode(payment: Payment): Mode {
  const payableCount = payment.paymentFragments.filter((pf) => pf.liability.amountToPay > 0).length;
  return payableCount > 0 ? 'recreate' : 'cancel';
}

export type Mode = 'recreate' | 'cancel';
